import { createFileRoute, redirect } from "@tanstack/react-router";

// Old English address of the privacy notice: permanent redirect to /datenschutz.
export const Route = createFileRoute("/privacy-policy")({
  loader: () => {
    throw redirect({ to: "/datenschutz", statusCode: 301 });
  },
});
